"use client";

import { usePathname } from "next/navigation";
import AppLayout from "./AppLayout";
import AuthGuard,{publicRoutes} from "./AuthGuard";
import Providers from "@/app/providers";

// const publicRoutes = [
//   "/",
//   "/login",
//   "/signup",
//   "/forgot-password",
//   "/register",
// ];

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isPublic = publicRoutes.includes(pathname);

  
  return (
    <Providers>
      {isPublic ? (
        <AppLayout>{children}</AppLayout>
      ) : (
        // <AuthGuard>
          <AppLayout>{children}</AppLayout>
        // </AuthGuard>
      )}
    </Providers>
  );
}
